import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { updateHantzUserSettings } from '../src/features/auth/authSlice';
import { useAppDispatch, useAppSelector } from './common/hooks';
import { uipApiInstance } from './services';
import { Spinner } from './components/atoms';

export const Hantz = ({ accessToken }: { accessToken: any }) => {
    const [data, setData] = useState('');
    const [loading, setLoading] = useState(true);
    const [iframeLoading, setIframeLoading] = useState(true);
    const dispatch = useAppDispatch();
    const global = useAppSelector((state) => state.global);
    const goeConfig = useAppSelector((state) => state.global.goeConfig);

    useEffect(() => {
        // Get Hantz User Settings
        if (isEmpty(goeConfig)) {
            dispatch(updateHantzUserSettings());
        }
    }, [updateHantzUserSettings]);

    useEffect(() => {
        // Define the API endpoint
        const fetchData = async () => {
            try {
                const response = await uipApiInstance({
                    method: 'GET',
                    url: '/api/advice/getconfig'
                });
                const data = response;
                const external_url = data.data.hantzconfig.external_url;
                const char = external_url.indexOf('?') > -1 ? '&' : '?';

                const url = `${external_url}${char}access_token=${accessToken}`;
                setData(url);
            } catch (err: any) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []); // If bearer token changes, refetch data

    // TODO:: delete if not used, Checks for User Agreement
    // useClickWrapAgreementsChecker();

    if (loading) return <Spinner enabled={loading} />;
    return (
        <>
            {!global.showAgreementModal && (
                <div>
                    <iframe
                        src={data}
                        className="hantzIframe"
                        loading="lazy"
                        onLoad={() => setIframeLoading(false)}
                        onError={() => {
                            console.error('Iframe failed to load');
                            setIframeLoading(false);
                        }}
                    />
                    {iframeLoading && <Spinner enabled={iframeLoading} />}
                </div>
            )}
        </>
    );
};
